import { NgTemplateOutlet } from '@angular/common';
import { Component, computed, inject, signal, Signal } from '@angular/core';
import { EmptyContentListElement } from '../../../components/empty-content-list-element/empty-content-list-element';
import { CONTENT_TYPE_TOKEN, TableContentService } from '../../../services/table-content.service';
import { ProfileService } from '../../../services/profile.service';
import { ApiHttpResponse, Coaching, IconType } from '@kinomap-dev/ng-ui-lib/core';
import { convertCoachingToCoachingContentTableItem } from '../../../utils/coaching-to-coaching-content-table-data.helpers';
import { Table } from '../../../components/table/table';
import { Paginator } from '../../../components/paginator/paginator';
import { FilterService } from '../../../services/filters.service';
import { TableColumnsService } from '../../../services/table-columns.service';

const tableHeaderElements: string[] = [
  'sport',
  'duration',
  'level',
  'sessions',
  'comments',
  'likes',
  // 'labels', // Hidden while the tags topic is on standby
];

@Component({
  selector: 'app-coaching-list',
  imports: [NgTemplateOutlet, EmptyContentListElement, Table, Paginator],
  templateUrl: './coaching-list.html',
  styleUrl: '../content-list.scss',
  providers: [
    FilterService,
    TableContentService,
    TableColumnsService,
    { provide: CONTENT_TYPE_TOKEN, useValue: 'coaching' },
  ],
})
export class CoachingList {
  public coachingTableContentService: TableContentService = inject(TableContentService);
  readonly tableColumnsService: TableColumnsService = inject(TableColumnsService);
  profileService: ProfileService = inject(ProfileService);

  readonly emptyList: Signal<boolean> = computed(
    () => (this.profileService.profile()?.videos_coaching_count ?? 0) === 0,
  );
  readonly actions: Signal<IconType[]> = signal<IconType[]>(['edit', 'options']);
  readonly coachingTableData: Signal<ApiHttpResponse<Coaching[]> | undefined> = this
    .coachingTableContentService.tableData as Signal<ApiHttpResponse<Coaching[]>>;

  private profileCoachingCount = computed(
    () => this.profileService.profile()?.videos_coaching_count ?? 0,
  );
  readonly skeletonCount: Signal<number> = computed(() => {
    if (this.profileCoachingCount() < this.coachingTableContentService.contentLimitPerPage()) {
      return this.profileCoachingCount();
    }
    return this.coachingTableContentService.contentLimitPerPage();
  });
  readonly tableData: Signal<any[] | undefined> = computed(() => {
    const data: Coaching[] | undefined = this.coachingTableData()?.data;
    if (!data || !Array.isArray(data)) return undefined;
    return data.map((row: Coaching) => {
      return convertCoachingToCoachingContentTableItem(row);
    });
  });

  constructor() {
    this.tableColumnsService.setColumns(tableHeaderElements);
  }
}
